export function formatLocalDateTimeFromUTC(
  input?: string | number | Date,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!input) return '-';

  let isoString: string | null = null;
  if (typeof input === 'string') {
    const trimmed = input.trim();
    // Normalize SQLite/Python space-separated datetime: "2026-04-20 10:30:00" → "2026-04-20T10:30:00"
    const normalized = trimmed.replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2})/, '$1T$2');
    // If no timezone info, assume UTC by appending 'Z'
    const hasTz = /([zZ]|[+-]\d{2}:?\d{2})$/.test(normalized);
    isoString = hasTz ? normalized : `${normalized}Z`;
  } else if (input instanceof Date) {
    isoString = input.toISOString();
  } else if (typeof input === 'number') {
    isoString = new Date(input).toISOString();
  }

  if (!isoString) return '-';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '-';

  return date.toLocaleString(undefined, options);
}

export function formatLocalDateFromUTC(input?: string | number | Date): string {
  return formatLocalDateTimeFromUTC(input, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
}

export function getUserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Local';
  } catch {
    return 'Local';
  }
}

export function getUserTimeZoneLabel(date?: Date): string {
  const d = date || new Date();
  const tz = getUserTimeZone();
  try {
    const parts = new Intl.DateTimeFormat(undefined, { timeZoneName: 'short' }).formatToParts(d);
    const short = parts.find(p => p.type === 'timeZoneName')?.value;
    return short ? `${tz} (${short})` : tz;
  } catch {
    return tz;
  }
}

